export default __webpack_public_path__ + "static/media/eraserIcon.4a69f7da.svg";